export default __webpack_public_path__ + "static/media/winner.31d71f33.png";